import { useState } from "react";
import SignUpForm from "src/components/auth/SignUpForm";
import Header from "src/components/header/Homeheader";

export default function BiAnnualSub() {
  const [authPage, setAuthPage] = useState(1);
  const plan = "premium";
  const plan_cost = "₦120000";
  const currency_code = "NGN";
  const plan_duration = "Bi-annually";
  return (
    <div className="h-screen">
      <Header />
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row justify-between">
          <div className="lg:w-2/5 space-y-5 p-5">
            <h2
              data-aos="fade-up"
              className="uppercase text-xs md:text-base text-brand-red-1 font-semibold"
            >
              Get started
            </h2>
            <h2
              data-aos="fade-up-right"
              className="text-2xl text-brand-1 sm:text-4xl font-medium"
            >
              <span className="font-semibold">Find</span> people with similar
              interests and <span className="font-semibold">build</span> your
              social network
            </h2>
            <p className="text-lg pt-5 font-medium">
              {
                <span className="text-brand-red-1 capitalize font-semibold">
                  {plan_duration} {plan}
                </span>
              }{" "}
              plan
            </p>
          </div>
          <div className="lg:w-1/2 p-5 space-y-10">
            <div className="flex gap-5 items-center">
              <span className="w-5 h-5 rounded-full bg-brand-1"></span>
              <p className="text-xs">
                Step {authPage} of 3 -{" "}
                {authPage !== 3 ? "Your bio" : "Your preferences"}
              </p>
            </div>
            <SignUpForm
              authPage={authPage}
              setAuthPage={setAuthPage}
              plan={plan}
              plan_cost={plan_cost}
              currency_code={currency_code}
              plan_duration={plan_duration}
              // userPreData={}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
